import { Grid } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { OPCheckBox } from '../../../OPcomponents/OPCheckBox'
import CVCard from './CVCard'
import { useCVSettings } from './CVSettingsContext'

export const PersonalDetailsPPTXCard: React.FC = () => {
  const { t } = useTranslation()
  const { state, handleSwitchChange } = useCVSettings()
  const { pptx_inc_title, pptx_inc_email, pptx_inc_picture, pptx_inc_summary, pptx_inc_workexperiencedescription } = state

  return (
    <CVCard title={t('CVTemplates.PersonalDetails')} description={t('CVTemplates.PersonalDetailsAndIntro')}>
      <Grid item>
        <OPCheckBox name='pptx_inc_title' label={t('CVTemplates.Title')} value={pptx_inc_title} onChangeState={handleSwitchChange} />
      </Grid>
      <Grid item>
        <OPCheckBox name='pptx_inc_email' label={t('CVTemplates.Email')} value={pptx_inc_email} onChangeState={handleSwitchChange} />
      </Grid>
      <Grid item>
        <OPCheckBox name='pptx_inc_picture' label={t('CVTemplates.Picture')} value={pptx_inc_picture} onChangeState={handleSwitchChange} />
      </Grid>
      <Grid item>
        <OPCheckBox
          name='pptx_inc_summary'
          label={t('Profile.ProfileSummary')}
          value={pptx_inc_summary}
          onChangeState={handleSwitchChange}
        />
      </Grid>
      <Grid item>
        <OPCheckBox
          name='pptx_inc_workexperiencedescription'
          label={t('Profile.ProfileWorkExperienceDescription')}
          value={pptx_inc_workexperiencedescription}
          onChangeState={handleSwitchChange}
        />
      </Grid>
    </CVCard>
  )
}
